import { SharedAngular } from '@Client/@types/sharedAngular';
import { HttpStatusCodes } from '@Shared.Angular/@types/core/contracts/constants/httpStatusCodes';
import IProcedureDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';
import { IStateParamsService } from 'angular-ui-router';

class RunnerPublicSopController {
  procedureId: Guid;
  procedure: IProcedureDetail;
  unauthorized: boolean;

  constructor(
    private $stateParams: IStateParamsService,
    private procedureApiService: SharedAngular.ProcedureApiService,
    private sessionService: SharedAngular.SessionService
  ) {
    this.procedureId = this.$stateParams.id;
    const user = this.sessionService.getUser();

    this.procedureApiService
      .getPublicProcedure(this.procedureId, user?.businessId)
      .then((procedure) => {
        this.procedure = procedure;
      })
      .catch((error: IResponseError) => {
        if (error.status === HttpStatusCodes.Unauthorized) {
          this.unauthorized = true;
        }
      });
  }
}

angular
  .module('flowingly.runner.publicsop')
  .controller('runnerPublicSopController', [
    '$stateParams',
    'procedureApiService',
    'sessionService',
    function ($stateParams, procedureApiService, sessionService) {
      const controller = new RunnerPublicSopController(
        $stateParams,
        procedureApiService,
        sessionService
      );
      return controller;
    }
  ]);
